import * as swcHelpers from '@swc/helpers';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { logMyOrdersClickEvent } from '../data-layer/my-orders-click.js';
import { getParsedDataFromLS } from '../Util/customer-name-persistor.js';

function getActivePath() {
    if (typeof window === 'undefined') {
        return '';
    }
    const url = new URL(window.location.href);
    return url.pathname;
}
function hasRoute(route) {
    return Boolean(route);
}
const useMyAccountMenuItems = ({ logout , routes , position , isUserLoggedIn , isAabEnabled  })=>{
    const intl = useIntl();
    const activePath = getActivePath();
    const loginLinkAttributes = useLink({
        route: 'auth.login'
    });
    const profileLinkAttributes = useLink({
        route: 'me.profile'
    });
    const prescriptionsLinkAttributes = useLink({
        route: 'me.prescription'
    });
    const ordersLinkAttributes = useLink({
        route: 'me.orders'
    });
    const appointmentsLinkAttributes = useLink({
        route: 'me.appointments'
    });
    const subscriptionsLinkAttributes = useLink({
        route: 'me.subscriptions'
    });
    const settingsLinkAttributes = useLink({
        route: 'me.settings'
    });
    const getLinkAttributes = (linkProps, { highlightOnUrlPath , isLinkEnabled , overrideLinkAttributes , skipHighlight =false  } = {})=>{
        if (!isLinkEnabled) {
            return undefined;
        }
        var ref;
        const active = activePath.startsWith((ref = highlightOnUrlPath !== null && highlightOnUrlPath !== void 0 ? highlightOnUrlPath : linkProps === null || linkProps === void 0 ? void 0 : linkProps.href) !== null && ref !== void 0 ? ref : 'unknown');
        var ref1, ref2;
        return swcHelpers.objectSpread({
            type: 'external'
        }, !skipHighlight ? {
            active
        } : null, {
            href: (ref1 = linkProps === null || linkProps === void 0 ? void 0 : linkProps.href) !== null && ref1 !== void 0 ? ref1 : '',
            onClick: (ref2 = linkProps === null || linkProps === void 0 ? void 0 : linkProps.onClick) !== null && ref2 !== void 0 ? ref2 : undefined
        }, overrideLinkAttributes);
    };
    const logoutItem = {
        label: intl.getLabel('account.menu.logOut'),
        parameters: {
            icon: 'logout',
            action: logout,
            testId: 'logout'
        },
        link: {
            href: '',
            type: 'external'
        }
    };
    const loginItem = {
        label: intl.getLabel('account.action.login'),
        parameters: {
            testId: 'login'
        },
        link: getLinkAttributes(loginLinkAttributes, {
            isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.profile),
            skipHighlight: true
        })
    };
    const userHasParsedDataFromLS = getParsedDataFromLS();
    let lastItem = logoutItem;
    if (!isUserLoggedIn && !userHasParsedDataFromLS) {
        lastItem = loginItem;
    }
    var ref3;
    const items = [
        {
            label: intl.getLabel('account.menu.accountDetails'),
            parameters: {
                icon: 'user',
                testId: 'profile'
            },
            link: getLinkAttributes(profileLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.profile)
            })
        },
        {
            label: intl.getLabel('account.menu.appointments'),
            parameters: {
                icon: 'calendar',
                testId: 'appointments'
            },
            link: getLinkAttributes(appointmentsLinkAttributes, {
                isLinkEnabled: isAabEnabled && hasRoute(routes === null || routes === void 0 ? void 0 : routes.appointments)
            })
        },
        {
            label: intl.getLabel('account.menu.prescriptions'),
            parameters: {
                icon: 'frame',
                testId: 'prescriptions'
            },
            link: getLinkAttributes(prescriptionsLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.prescriptions)
            })
        },
        {
            label: intl.getLabel('account.menu.orders'),
            parameters: {
                icon: 'orders',
                testId: 'orders'
            },
            link: getLinkAttributes(ordersLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.orders),
                overrideLinkAttributes: position ? {
                    href: (ref3 = ordersLinkAttributes === null || ordersLinkAttributes === void 0 ? void 0 : ordersLinkAttributes.href) !== null && ref3 !== void 0 ? ref3 : '',
                    onClick: (e)=>{
                        return logMyOrdersClickEvent(position), ordersLinkAttributes === null || ordersLinkAttributes === void 0 ? void 0 : ordersLinkAttributes.onClick(e);
                    }
                } : undefined
            })
        },
        {
            label: intl.getLabel('account.menu.subscriptions'),
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptions'
            },
            link: getLinkAttributes(subscriptionsLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.subscriptions)
            })
        },
        {
            label: intl.getLabel('account.menu.settings'),
            parameters: {
                icon: 'folded-page-with-text',
                testId: 'settings'
            },
            link: getLinkAttributes(settingsLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.settings)
            })
        },
        lastItem, 
    ];
    const hasLink = (item)=>{
        var ref;
        return ((ref = item.link) === null || ref === void 0 ? void 0 : ref.href) && item.link.href !== '';
    };
    const hasAction = (item)=>{
        var ref;
        return (ref = item.parameters) === null || ref === void 0 ? void 0 : ref.action;
    };
    return items.filter((item)=>hasLink(item) || hasAction(item)
    );
};

export { useMyAccountMenuItems };
//# sourceMappingURL=use-my-account-menu-items.js.map
